import { render, staticRenderFns } from "./detail2.vue?vue&type=template&id=5e5f141a&scoped=true&"
import script from "./detail2.vue?vue&type=script&lang=js&"
export * from "./detail2.vue?vue&type=script&lang=js&"
import style0 from "./detail2.vue?vue&type=style&index=0&id=5e5f141a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5f141a",
  null
  
)

export default component.exports